@if (item) {
  <ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
}

<ng-template #gbtyp00>
  @if (item.mutationNrNBIdent && item.mutationNrNummer) {
    {{ item.mutationNrNBIdent }}/{{ item.mutationNrNummer }}
  }
</ng-template>
